import React, { useState } from "react";
import { useEffect } from "react";
import { LayoutBase } from "../../components/LayoutBase";
import api from "../../services/api";

import { ProjectItem } from "../../components/ProjectItem";


function ProjectsValueMart() {
  const [loading, setLoading] = useState(true);

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get('projects')
      .then(response => {
        setProjects(response.data.filter(project => project.isValueMart))
        setLoading(false);
      });
  }, [])


  return (
    <>
      {loading ? (
        <LayoutBase>
          <h1>Carregando ...</h1>
        </LayoutBase>
      ) : !loading && projects.length === 0 ? (
        <LayoutBase>
          <h1>Não existe imóveis</h1>
        </LayoutBase>
      ) : (
        <LayoutBase>
          <div className="projects">
            {projects.map(project => <ProjectItem key={project.id} project={project} />)}
          </div>
        </LayoutBase>
      )}
    </>
  );
}

export default ProjectsValueMart;
